import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  NavLink,
  Redirect,
} from 'react-router-dom'
import { HashLink as Link } from 'react-router-hash-link';
import './css/index.css';

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return (
    React.createElement(component, finalProps)
  );
}

const PropsRoute = ({ component, ...rest }) => {
  return (
    <Route {...rest} render={routeProps => {
      return renderMergedProps(component, routeProps, rest);
    }} />
  );
}

class NavMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      compactMargin: false,
    }
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll() {
    var fromTop = window.pageYOffset;//document.documentElement.scrollTop;

    this.setState({
      compactMargin: (fromTop > 0) ? true : false,
    });
  }

  render() {
    const marginClass = this.state.compactMargin ? "compact-margin" : {};
    const activeStyle = this.state.compactMargin ? {
      margin: "22px 10px",
      outline: "2px solid #dbdbdb",
      cursor: "default",
    } : {
        margin: "22px 30px",
        outline: "2px solid #dbdbdb",
        cursor: "default",
      }

    return (
      <ul class="nav" id="nav-full">
        <li><NavLink to='/contact' class={marginClass} activeStyle={activeStyle}>CONTACT</NavLink></li>
        <li><NavLink to='/projects' class={marginClass} activeStyle={activeStyle}>PORTFOLIO</NavLink></li>
        <li><NavLink exact={true} to='/' class={marginClass} activeStyle={activeStyle}>ABOUT ME</NavLink></li>
      </ul>
    )
  }
}

class NavMenuCompact extends React.Component {
  render() {
    return (
      <div class="nav" id="nav-compact">
        <button class="material-icons">view_headline</button>
        <div id="nav-compact-items">
          <NavLink exact={true} to='/' activeClassName="nav-active">ABOUT ME</NavLink>
          <NavLink to='/projects' activeClassName="nav-active">PORTFOLIO</NavLink>
          <NavLink to='/contact' activeClassName="nav-active">CONTACT</NavLink>
        </div>
      </div>
    )
  }
}

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: "rgb(0,0,0,0)",
    }
    this.handleScroll = this.handleScroll.bind(this);
  }

  renderSwitch(headerFormat) {
    switch (headerFormat) {
      case true:
        return (
          <div id="navbar">
            <h1 class="nav">
              <img alt="" src={require("./images/logo-white-compact.png")} height="48" class="logo" />
            </h1>
            <NavMenuCompact />
          </div>)
      case false:
        return (
          <div id="navbar">
            <h1 class="nav">
              <img alt="" src={require("./images/logo-white-compact.png")} height="48" class="logo" />
            </h1>
            <NavMenu />
          </div>)
      default:
        return null;
    }
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll() {
    var fromTop = window.pageYOffset;//document.documentElement.scrollTop;
    var fromTopShrunk = fromTop / 250;
    if (fromTopShrunk > 254) {
      this.setState({
        backgroundColor: "rgba(0,0,0,0)",
      });
    }
    else {
      this.setState({
        backgroundColor: "rgba(0,0,0," + fromTopShrunk + ")"
      });
    }
  }
  render() {
    return (
      <header style={{
        backgroundColor: this.state.backgroundColor,
      }}>
        {this.renderSwitch(this.props.mobile)}
        <br />
        <div id="extra-links">
          <a href="https://angel.co/hans-tang"><i class="fab fa-angellist"></i></a>
          <a href="https://www.facebook.com/hans.tang3"><i class="fab fa-facebook"></i></a>
          <a href="https://github.com/htang014"><i class="fab fa-github"></i></a>
          <a href="https://www.linkedin.com/in/hans-tang-a5380599/"><i class="fab fa-linkedin-in"></i></a>
        </div>
      </header>
    );
  }
}

class HomeIntroText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      top: "0px",
      transform: "translateY(0px)",
      opacity: 1
    }
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll() {
    var fromTop = document.documentElement.scrollTop;
    this.setState({
      top: fromTop + "px",
      transform: "translateY(" + fromTop / 2 + "px)",
      opacity: 1 - fromTop / 250
    });
  }
  render() {
    var mobileClass = this.props.mobile ? "mobile" : {};
    return (
      <div>
        <img style={{
          top: this.state.top,
          transform: this.state.transform,
          opacity: this.state.opacity
        }}
          src={require("./images/logo-white-extended.png")} height="48px"
        />
        <h2
          style={{
            top: this.state.top,
            transform: this.state.transform,
            opacity: this.state.opacity
          }}
          class={mobileClass}>
          C++ | ANDROID | WEB
        </h2>
      </div>
    )
  }
}

class HomeContent extends React.Component {
  handleClick(menuItem) {
    this.props.pageChange(menuItem);
  }

  render() {
    var mobileClass = this.props.mobile ? "mobile" : {};
    return (
      <div class="body-container">
        <div class="intro" id="home-intro">
          <HomeIntroText mobile={this.props.mobile} />
        </div>
        <div class="info" id="home-info">
          <div class="section-top">
            <div id="about-me" class={mobileClass}>
              <div id="about-image" class={mobileClass}>
                <img src={require("./images/about-me-photo.png")} height="140px" width="140px" />
              </div>
              <div
                id="about-text"
                class={mobileClass}>
                <p>Hi! I'm Hans. If you're in need of software or hardware development talent, take some time to read why I'm the man for the job.</p>
              </div>
            </div>
          </div>
          <div class="section-med">
            <div id="services">
              <h2>What I Can Do For You</h2>
              <div class="s2-bullets">
                <h3 class="material-icons">web</h3>
                <h3>Web/UI Development</h3>
                <p>
                  Experience with a variety of web technologies and assets.  Real-world experience.  Check out my projects!
                </p>
              </div>
              <div class="s2-bullets">
                <h3 class="material-icons">computer</h3>
                <h3>General Programming</h3>
                <p>A solid foundation in C/C++ development, and meticulous awareness of data structures and system optimization</p>
              </div>
              <div class="s2-bullets">
                <h3 class="material-icons">phone_in_talk</h3>
                <h3>Communication & Documentation</h3>
                <p>Excellent writing skills, and experience writing technical documentation in both academic and corporate settings</p>
              </div>
            </div>
            <div id="technologies">
              <h2>Technologies I Use</h2>
              <ul>
                <li><i class="devicon-react-original-wordmark"></i></li>
                <li><i class="devicon-jquery-plain-wordmark"></i></li>
                <li><i class="devicon-wordpress-plain-wordmark"></i></li>
                <li><i class="devicon-html5-plain-wordmark"></i></li>
                <li><i class="devicon-sass-original"></i></li>
                <li><i class="devicon-mysql-plain-wordmark"></i></li>
                <li><i class="devicon-amazonwebservices-plain-wordmark"></i></li>
                <li><i class="devicon-nodejs-plain-wordmark"></i></li>
                <li><i class="devicon-php-plain"></i></li>
                <li><i class="devicon-c-plain"></i></li>
                <li><i class="devicon-cplusplus-plain"></i></li>
                <li><i class="devicon-java-plain-wordmark"></i></li>
                <li><i class="devicon-python-plain-wordmark"></i></li>
                <li><i class="devicon-android-plain-wordmark"></i></li>
                <li><i class="devicon-git-plain-wordmark"></i></li>
              </ul>
            </div>
            <div id="platforms">
              <h2>Daily Platforms</h2>
              <ul>
                <li><i class="devicon-windows8-original"></i></li>
                <li><i class="devicon-linux-plain"></i></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class ProjectsIntroText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      top: "0px",
      transform: "translateY(0px)",
      opacity: 1
    }
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll() {
    var fromTop = document.documentElement.scrollTop;
    this.setState({
      top: fromTop + "px",
      transform: "translateY(" + fromTop / 2 + "px)",
      opacity: 1 - fromTop / 250
    });
  }
  render() {
    var mobileClass = this.props.mobile ? "mobile" : {};
    return (
      <div>
        <h2
          style={{
            top: this.state.top,
            transform: this.state.transform,
            opacity: this.state.opacity
          }}
          class={mobileClass}>
          PORTFOLIO
        </h2>
        <a
          style={{
            top: this.state.top,
            transform: this.state.transform,
            opacity: this.state.opacity
          }}
          href="./files/resume.pdf"
          download="resume.pdf">
          DOWNLOAD RESUME
        </a>
      </div>
    )
  }
}

class ProjectsContent extends React.Component {
  render() {
    var mobileClass = this.props.mobile ? "mobile" : {};
    return (
      <div class="body-container">
        <div class="intro" id="projects-intro">
          <ProjectsIntroText mobile={this.props.mobile} />
        </div>
        <div class="info" id="projects-info">
          <div class="section-top">
            <div id="project-list" class={mobileClass} >
              {/* <div class="project-divider"></div> */}
              <div class="project" id="project-1">
                <a href="http://hanst.me" class={mobileClass}>PERSONAL WEBSITE</a>
                <div class={"project-image " + mobileClass}></div>
                <div
                  class={"project-text " + mobileClass}>
                  <h2>hanst.me</h2>
                  <p>You're already here!
                    <br />
                    <br /><b>Technologies Used:</b>
                    <br /> ReactJS • SASS • PHP • AWS
                  </p>
                  <img alt="" src={require("./images/project1.jpg")} height="40" class="logo" />
                </div>
              </div>
              {/* <div class="project-divider"></div> */}
              <div class="project" id="project-2">
                <a href="https://www.crmtech.us" class={mobileClass}>CRM TECH</a>
                <div class={"project-image " + mobileClass}></div>
                <div
                  class={"project-text " + mobileClass}>
                  <h2>crmtech.us</h2>
                  <p>CRM Tech is a long-time
                    <br />cultural resources 
                    <br />management firm.  I redesigned
                    <br />their previously outdated
                    <br />website from scratch.
                    <br />
                    <br /><b>Technologies Used:</b>
                    <br /> ReactJS • SASS • PHP • MySQL
                    <br />• WordPress
                  </p>
                  <img alt="" src={require("./images/project2.jpg")} height="40" class="logo" />
                </div>
              </div>
              <div class="project" id="project-3">
                <a href="https://github.com/htang014/Jot-Data-Manager-for-WordPress" class={mobileClass}>JOT FOR WORDPRESS</a>
                <div class={"project-image " + mobileClass}></div>
                <div
                  class={"project-text " + mobileClass}>
                  <h2>Jot Data Manager</h2>
                  <p>Jot is a MySQL database 
                    <br />management plugin 
                    <br />for WordPress. Designed 
                    <br />to help administrators 
                    <br />modify tables quickly 
                    <br />and easily.
                    <br />
                    <br /><b>Technologies Used:</b>
                    <br /> PHP • MySQL • WordPress
                  </p>
                  <img alt="" src={require("./images/project3.jpg")} height="40" class="logo" />
                </div>
              </div>
            </div>
          </div>
          <div class="section-bottom">
            <h2>Check out my other work.</h2>
            <a href="https://github.com/htang014"><i class="fab fa-github"></i></a>
            <a href="https://www.linkedin.com/in/hans-tang-a5380599/"><i class="fab fa-linkedin-in"></i></a>
          </div>
        </div>

      </div>
    )
  }
}

class ContactIntroText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      top: "0px",
      transform: "translateY(0px)",
      opacity: 1
    }
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll() {
    var fromTop = document.documentElement.scrollTop;
    this.setState({
      top: fromTop + "px",
      transform: "translateY(" + fromTop / 2 + "px)",
      opacity: 1 - fromTop / 250
    });
  }
  render() {
    var mobileClass = this.props.mobile ? "mobile" : {};
    return (
      <div>
        <h2
          style={{
            top: this.state.top,
            transform: this.state.transform,
            opacity: this.state.opacity
          }}
          class={mobileClass}>
          CONTACT ME
        </h2>
        <h3 style={{
          top: this.state.top,
          transform: this.state.transform,
          opacity: this.state.opacity
        }}>
          GLAD TO TALK
        </h3>
      </div>
    )
  }
}

class ContactContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      subject: "proposal",
      message: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    var name = event.target.name;
    var value = event.target.value;
    if (name === "phone") {
      value = value.replace(/[\D\s._-]+/g, "");
      value = value.toString().substring(0, 10);
      var size = value.length;
      if (size === 0) {
        // pass
      } else if (size < 4) {
        value = '(' + value;
      } else if (size < 7) {
        value = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6);
      } else {
        value = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6) + ' - ' + value.substring(6, 10);
      }
      value = (value === "(0") ? "" : value;
    }
    this.setState({
      [name]: value
    });
  }
  handleSubmit(event) {
    alert("Temporary alert");
    event.preventDefault();
  }

  renderSwitch(nameFormat) {
    switch (nameFormat) {
      case true:
        return (
          <tr>
            <td class="label-cell">Name *</td>
            <td class="field-cell">
              <input
                type="text"
                name="firstName"
                placeholder="First"
                value={this.state.firstName}
                onChange={this.handleChange} />
            </td>
            <td class="field-cell">
              <input
                type="text"
                name="lastName"
                placeholder="Last"
                value={this.state.lastName}
                onChange={this.handleChange} />
            </td>
          </tr>
        )
      case false:
        return (
          <tr>
            <td class="label-cell">Name *</td>
            <td class="field-cell">
              <input
                type="text"
                name="firstName"
                placeholder="First"
                value={this.state.firstName}
                onChange={this.handleChange} />
              <input
                type="text"
                name="lastName"
                placeholder="Last"
                value={this.state.lastName}
                onChange={this.handleChange} />
            </td>
          </tr>
        )
      default:
        return null;
    }
  }

  render() {
    var mobileClass = this.props.mobile ? "mobile" : {};
    return (
      <div class="body-container">
        <div class="intro" id="contact-intro">
          <ContactIntroText mobile={this.props.mobile} />
        </div>
        <div class="info" id="contact-info">
          <div class="section-top">
            <div id="contact-form" class={mobileClass} >
              <form action={require("./php/contactform.php")} method="post" >
                <table>
                  {this.renderSwitch(this.props.mobile)}
                  <tr>
                    <td class="label-cell">Email *</td>
                    <td class="field-cell"><input
                      type="text"
                      name="email"
                      value={this.state.email}
                      onChange={this.handleChange} /></td>
                  </tr>
                  <tr>
                    <td class="label-cell">Phone</td>
                    <td class="field-cell"><input
                      type="text"
                      id="phone"
                      name="phone"
                      value={this.state.phone}
                      onChange={this.handleChange} /></td>
                  </tr>
                  <tr>
                    <td class="label-cell">Subject *</td>
                    <td class="field-cell">
                      <select name="subject" value={this.state.subject} onChange={this.handleChange}>
                        <option selected value="Recruitment">Recruitment</option>
                        <option selected value="Proposal">Proposal</option>
                        <option value="Inquiry">Inquiry</option>
                        <option value="Other">Other</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td class="label-cell">Message *</td>
                    <td class="field-cell"><textarea
                      name="message"
                      value={this.state.message}
                      onChange={this.handleChange} /></td>
                  </tr>
                </table>
                <input id="submit" type="submit" value="Submit" />
              </ form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class Footer extends React.Component {
  render() {
    return (
      <div class="section-footer">
        <div id="footer-contact">
          <div id="s3-content">
            <div class="s3-bullets">
              <h3>E-mail</h3>
              <p>
                hanstang007@gmail.com
                <br />&nbsp;
              </p>
            </div>
            <div class="s3-bullets">
              <h3>Phone</h3>
              <p>
                Cell: 951-205-7250
                <br />Home: 909-799-9473
              </p>
            </div>
            <div class="s3-bullets">
              <h3>Address</h3>
              <p>
                1738 Fairmont Drive
                <br />Redlands, CA 92373
              </p>
            </div>
          </div>
        </div>
        <div id="footer-copyright">
          <h4>© 2018 | Hosted by AWS</h4>
        </div>
      </div>
    );
  }
}

class Page extends React.Component {
  constructor(props) {
    super(props);
    var width = document.documentElement.clientWidth;
    this.state = (width > 600) ? { mobile: false } : { mobile: true };
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  handleResize() {
    var width = document.documentElement.clientWidth;
    this.setState((width > 600) ? { mobile: false } : { mobile: true });
  }

  render() {
    return (
      <body>
        <Header mobile={this.state.mobile} />
        <Switch>
          <PropsRoute exact path="/" component={HomeContent} mobile={this.state.mobile} />
          <PropsRoute path="/projects" component={ProjectsContent} mobile={this.state.mobile} />
          <PropsRoute path="/contact" component={ContactContent} mobile={this.state.mobile} />
        </Switch>
        <Footer mobile={this.state.mobile} />
      </body>
    );
  }

}

ReactDOM.render((
  <Router>
    <Page />
  </Router>
), document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js